const EUR = {
  countryConfig: {
    accountNumber: {
      visible: false,
    },
    swift: {
      label: "bankDetails.swift",
      visible: true,
      required: true,
    },

    IBAN: {
      visible: true,
      label: "bankDetails.IBAN",
      alphanumeric: true,
      required: true,
    },
    bankName: {
      visible: false,
      required: false,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { EUR };
